module.exports = __webpack_public_path__ + "img/hm1.c162ba3d.png";